import { MEMBERSHIP_CHANGE_PLAN, MEMBERSHIP_CHANGE_PLAN_DONE, MEMBERSHIP_CHANGE_PLAN_ERROR, MEMBERSHIP_CHANGE_PLAN_RESET } from './actionTypes';
export const membershipChangePlan = (data) => ({
    type: MEMBERSHIP_CHANGE_PLAN,
    data
});
export const membershipChangePlanDone = () => ({
    type: MEMBERSHIP_CHANGE_PLAN_DONE
});
export const membershipChangePlanError = (data) => ({
    type: MEMBERSHIP_CHANGE_PLAN_ERROR,
    data
});
export const membershipChangePlanReset = () => ({
    type: MEMBERSHIP_CHANGE_PLAN_RESET
});
//# sourceMappingURL=actionCreators.js.map